import React, { useEffect } from 'react';
import { bindActionCreators, Dispatch } from 'redux';

import styles from './Login.module.scss';
import $script from 'scriptjs';
import { loginActions } from '../../store/login/actions';
import { connect } from 'react-redux';
import { APPLE_CLIENTID, APPLE_REDIRECT } from '../../constants/login';
interface DispatchProps {
  actions: {
    newAppleLoginRequest: (token: string, email?: string, name?: string) => any;
  };
}

export const AppleButton: React.FC<any> = (props) => {
  let win: any = window;
  useEffect(() => {
    $script.get(
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
      () => {
        win.AppleID.auth.init({
          clientId: APPLE_CLIENTID,
          redirectURI: APPLE_REDIRECT,
          scope: 'name email',
          usePopup: true,
        });
      },
    );
  });

  return (
    <div className={styles.AppleButton}>
      <button
        data-type="sign in"
        type={'button'}
        onClick={() =>
          win.AppleID.auth
            .signIn()
            .then((data: any) => {
              if (
                data.authorization.id_token &&
                data.authorization.id_token.length > 0
              ) {
                if (data.user) {
                  props.actions.newAppleLoginRequest(
                    data.authorization.id_token,
                    data.user.email,
                    data.user.name.firstName + data.user.name.lastName,
                  );
                } else {
                  props.actions.newAppleLoginRequest(
                    data.authorization.id_token,
                  );
                }
              }
            })
            .catch((e: any) => {})
        }
      >
        {props.text || <img src={props.image} />}
      </button>
    </div>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      newAppleLoginRequest: loginActions.appleLoginRequest,
    },
    dispatch,
  ),
});

export const AppleButtonConnected = connect<DispatchProps>(
  null,
  mapDispatchToProps,
)(AppleButton);
